/**
 * Sample products the homepage specimen cycles through. Copy lives under
 * `home.specimen.products.<id>` in `auth.json`; the attribute lists here are the i18n
 * keys of each product's chips (`beforeAttributes.<key>` / `attributes.<key>`).
 * Every product carries 7 enriched chips so the card keeps a steady height.
 */
export interface SpecimenProduct {
  id: string;
  /** Attribute count on the raw feed record. */
  beforeCount: number;
  /** Attribute count after enrichment — the chips are a sample of these. */
  afterCount: number;
  beforeAttributes: readonly string[];
  attributes: readonly string[];
}

export const SPECIMEN_PRODUCTS: readonly SpecimenProduct[] = [
  {
    id: 'bag',
    beforeCount: 2,
    afterCount: 14,
    beforeAttributes: ['color', 'material'],
    attributes: ['type', 'material', 'strap', 'hardware', 'closure', 'occasion', 'trend'],
  },
  {
    id: 'sneaker',
    beforeCount: 2,
    afterCount: 16,
    beforeAttributes: ['color', 'size'],
    attributes: ['type', 'upper', 'sole', 'fastening', 'feature', 'weight', 'trend'],
  },
  {
    id: 'dress',
    beforeCount: 2,
    afterCount: 12,
    beforeAttributes: ['pattern', 'length'],
    attributes: ['type', 'length', 'pattern', 'sleeves', 'waist', 'neckline', 'trend'],
  },
];
